@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('isView')) {
  <div class="container-fluid mb-4 ">
    <!-- Combined Header and Filter Section -->
    <div class="combined-header-filter-section" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
      <!-- Header Content -->
      <div class="header-content">
        <div class="title-section">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
                <path d="M8 14h.01"></path>
                <path d="M12 14h.01"></path>
                <path d="M16 14h.01"></path>
              </svg>
            </div>
            <div class="title-text-container">
              <h1 class="main-title">Leave Management</h1>
              <p class="subtitle">Track and manage employee leave requests</p>
            </div>
          </div>
        </div>
        
        <div class="action-buttons">
          @if (isavailablefeature('isViewLeaveReport')) {
          <button type="button" class="modern-btn report-btn" [routerLink]="'/leave-report'">
            <div class="btn-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14,2 14,8 20,8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </svg>
              <span>Leave Report</span>
            </div>
          </button>
          }
        </div>
      </div>
      

       <!-- Filter Toggle Button with Action Buttons -->
      <div class="filter-toggle-section">
        <button class="filter-toggle-btn" (click)="toggleFilterSection()" [attr.aria-expanded]="isFilterExpanded">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-icon">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>{{ isFilterExpanded ? 'Hide Filters' : 'Show Filters' }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron-icon" [class.rotated]="isFilterExpanded">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        
          <div class="action-controls">
                <button type="button" class="control-btn apply-btn" (click)="getLeaveMangement()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  Apply Filters
                </button>

                <button type="button" class="control-btn reset-btn" (click)="resetfilter()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="1 4 1 10 7 10"></polyline>
                          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                        </svg>
                        Reset
                </button>
            </div>
      </div>




      <!-- Filter Content -->
      <div class="filter-content" [@slideDown]="isFilterExpanded ? 'expanded' : 'collapsed'" *ngIf="isFilterExpanded">
        
        <div class="search-filters">
          <div class="input-group">
            <label>Search Employee</label>
            <div class="input-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="M21 21l-4.35-4.35"></path>
              </svg>
              <input type="text" placeholder="Search by name..." [(ngModel)]="nameFilter" />
            </div>
          </div>
          
          <div class="input-group">
            <label>Start Date</label>
            <div class="input-wrapper date-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <input type="text" placeholder="Select start date" [value]="formatDisplay(startDateFilter)" readonly (click)="openStartPicker()" />
              <input #startPicker type="date" [value]="formatNative(startDateFilter)" (change)="applyStart($event)" class="native-date-input" />
            </div>
          </div>
          
          <div class="input-group">
            <label>End Date</label>
            <div class="input-wrapper date-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <input type="text" placeholder="Select end date" [value]="formatDisplay(endDateFilter)" readonly (click)="openEndPicker()" />
              <input #endPicker type="date" [value]="formatNative(endDateFilter)" (change)="applyEnd($event)" class="native-date-input" />
            </div>
          </div>

           <div class="input-group">
              <label>Category</label>
              <div class="input-wrapper">
                <select [(ngModel)]="leaveCategory">
                  <option value="" disabled selected>Select Category</option>
                  @for (leave of leavenames; track leave) {
                              <option [value]="leave?.leave_name">{{ leave.leave_name }}</option>
                            }
                </select>
              </div>
            </div>


            <div class="input-group">
              <label>Status</label>
              <div class="input-wrapper">
                <select [(ngModel)]="leaveStatus">
                  <option value="">Select Status</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                  <option value="recommended">Recomended</option>
                </select>
              </div>
            </div>


             <div class="input-group">
              <label>Type</label>
              <div class="input-wrapper">
                <select [(ngModel)]="leavetype">
                  <option value="">Select Type</option>
                  <option value="full">Full Leave</option>
                  <option value="short">Short Leave</option>
                 
                </select>
              </div>
            </div>

             <div class="input-group">
              <label>Payment Status</label>
              <div class="input-wrapper">
                <select [(ngModel)]="leavePayment">
                  <option value="">Select Type</option>
                  <option value="paid">Paid Leave</option>
                  <option value="unpaid">Unpaid Leave</option>
                 
                </select>
              </div>
            </div>


           



        </div>


       


        
        
      </div>
    </div>
    
    <!-- Modern Card-Based Leave Listing -->
    <div class="leaves-grid-container">
      @for (a of pagedData ; track a) {
      <div class="leave-card" [ngClass]="{
        'card-approved': a.status === 'approved', 
        'card-rejected': a.status === 'rejected', 
        'card-recommended': a.status === 'recommended',
        'card-pending': a.status === 'pending',
        'dark-card': selectedMode === 'dark'
      }">
        
        <!-- Card Header - Employee Info & Actions -->
        <div class="card-header-section">
          <div class="employee-info">
            <div class="employee-avatar">
              <!-- <span>{{ (a.user?.first_name?.charAt(0) || '') + (a.user?.last_name?.charAt(0) || '') }}</span> -->
           <div *ngIf="a.user?.profile_image; else initials" class="avatar">
              <img [src]="a.user.profile_image" alt="Profile Image">
            </div>
            <ng-template #initials>
              <div class="avatar-initials">
                {{ (a.user?.first_name?.charAt(0) || '') + (a.user?.last_name?.charAt(0) || '') }}
              </div>
            </ng-template>
            </div>
            <div class="employee-details">
              <h3 class="employee-name">{{ a.user?.first_name }} {{ a.user?.last_name }}</h3>
              @if (a.leave_version == '1' && a.user) {
              <div class="employee-meta-inline">
                <span class="meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  ID: {{ a.user.attendance_user_id || 'N/A' }}
                </span>
                <span class="meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  {{ a.user.email }}
                </span>
                <span class="meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                  {{ a.user.designation?.designation_name || 'N/A' }}
                </span>
                
                <!-- Leave Type Badge in same row -->
                <div class="leave-type-badge-wrapper">
                  <div class="leave-type-badge">
                    <span class="leave-type-name">{{ a.leave_name | titlecase }}</span>
                    <span class="leave-payment-type">{{ a.leave_payment_status | titlecase }}</span>
                  </div>
                  @if (a.monthly_sequence > 2) {
                    <span
                      style="background:#fff3cd;color:#d63031;padding:6px 12px;border-radius:14px;font-size:12px;font-weight:600;margin-left:8px;white-space:nowrap;display:inline-flex;align-items:center;gap:6px;border:1px solid #ffe8a8;cursor:pointer;position:relative;"
                      [attr.data-tooltip]="'This is the ' + a.monthly_sequence + getOrdinalSuffix(a.monthly_sequence) + ' leave request from this user. User can only apply 2 leaves in a month.'"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0;">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                      </svg>

                      {{ a.monthly_sequence }}{{ getOrdinalSuffix(a.monthly_sequence) }} Request
                    </span>
                  }
                </div>
              </div>
              }
            </div>
          </div>
          
          <!-- Action Buttons Only on Right Side -->
          <div class="header-right-section">
            
            <!-- Action Buttons in Header -->
            @if ((isLeaveApprovedPermission() || isLeaveRejectPermission() || isUpdateLeavePermission()) || a.status !== 'pending') {
            <div class="action-buttons-compact">
              @if (isavailablefeature('isUpdate') && a.status === 'pending' && ((a.leave_version == '1' && a.user_id != current_user_id) || (a.leave_version != '1'))) {
              <button class="action-btn-compact btn-update" data-toggle="modal" data-target="#updateModal" (click)="onClickupatedLeave(a.index)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                Update
              </button>
              }
              
              @if (((a.leave_version == '1' && isShowApprovalButtons(a) && a.user_id != current_user_id) || (a.leave_version != '1' && a.status === 'pending')) && isavailablefeature('isReject')) {
              <button class="action-btn-compact btn-reject" data-toggle="modal" data-target="#rejectModal" (click)="onClickRejectLeave(a.index)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                Reject
              </button>
              }
              
              @if (((a.leave_version == '1' && isShowApprovalButtons(a) && a.user_id != current_user_id) || (a.leave_version != '1' && a.status === 'pending')) && isavailablefeature('isAccept')) {
              <button class="action-btn-compact btn-approve" data-toggle="modal" data-target="#approveModal" (click)="storeValue(a.index, a.approval_or_recommendation)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {{ a.leave_version == '1' ? getApprovalButtonLabel(a) : 'Approve' }}
              </button>
              }
              
              @if (a.leave_version == '1' && isShowredobutton(a) && isavailablefeature('isUndo')) {
              <button class="action-btn-compact btn-undo" data-toggle="modal" data-target="#redoModal" (click)="onClickredo(a.index)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="1 4 1 10 7 10"></polyline>
                  <path d="M3.51 15a9 0 1 0 2.13-9.36L1 10"></path>
                </svg>
                Undo
              </button>
              }
            </div>
            }
          </div>
        </div>

        <!-- Card Body - Leave Details (Compact Layout) -->
        <div class="card-body-section">
          <!-- Compact Details Row -->
          <div class="details-compact">
            @if (a.start_date === a.end_date) {
            <!-- Single Date when start and end are the same -->
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Date:</span>
                <span class="detail-value-compact">{{ a.start_date | date: 'd MMM yyyy' }}</span>
              </div>
            </div>
            }
            @else {
            <!-- Separate Start and End dates -->
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Start:</span>
                <span class="detail-value-compact">{{ a.start_date | date: 'd MMM yyyy' }}</span>
              </div>
            </div>

            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">End:</span>
                <span class="detail-value-compact">{{ a.end_date | date: 'd MMM yyyy' }}</span>
              </div>
            </div>
            }

            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Duration:</span>
                @if (a.type.title==='Full Leave') {
                <span class="detail-value-compact">{{ calculateDiff(a.start_date, a.end_date) }} {{ calculateDiff(a.start_date, a.end_date) == 1 ? 'day' : 'days' }}</span>
                }
                @if (a.leave_type_id == 3 && (!a.shortLeave_hours || a.shortLeave_hours == 0 || a.shortLeave_hours === '')) {
                <span class="detail-value-compact">0.5 day</span>
                }
                @if (a.leave_type_id == 3 && (a.shortLeave_hours !== null && a.shortLeave_hours !== undefined && a.shortLeave_hours != 0 && a.shortLeave_hours !== '')) {
                <span class="detail-value-compact">{{ a.shortLeave_hours }} hours</span>
                }
              </div>
            </div>

            <!-- Short Leave Time Details -->
            @if (a.leave_type_id == 3 && (a.shortLeave_hours !== null && a.shortLeave_hours !== undefined && a.shortLeave_hours != 0 && a.shortLeave_hours !== '')) {
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Time:</span>
                <span class="detail-value-compact">{{ a.shortLeave_start_time.slice(0, 5) }} - {{ a.shortLeave_end_time.slice(0, 5) }}</span>
              </div>
            </div>
            }

            <!-- Applied Date -->
            <div class="detail-item-compact">
              <div class="detail-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <path d="M8 14h.01"></path>
                  <path d="M12 14h.01"></path>
                  <path d="M16 14h.01"></path>
                </svg>
              </div>
              <div class="detail-content-compact">
                <span class="detail-label-compact">Applied:</span>
                <span class="detail-value-compact">{{ a.applied_date | date: 'd MMM yyyy' }}</span>
              </div>
            </div>
          </div>

          <!-- Two Column Layout: Description (Left) + Timeline (Right) -->
          <div class="content-two-column">
            <!-- Left Column: Description & Admin Info -->
            <div class="left-column">
              <!-- Description -->
              <div class="description-section-compact">
                <div class="description-header-compact">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                  </svg>
                  <span>Description</span>
                </div>
                <p class="description-text-compact" [innerHTML]="a.description || a.description"></p>
              </div>

              <!-- Rejected Reason -->
              @if (a.status === 'rejected' && a.rejected_reason) {
              <div class="rejection-section-compact">
                <div class="rejection-header-compact">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                  <span>Rejection Reason</span>
                </div>
                <p class="rejection-text-compact">{{ a.rejected_reason }}</p>
              </div>
              }

              <!-- Old Version Admin Info -->
              @if (a.leave_version != '1' && (a.status === 'approved' || a.status === 'rejected')) {
              <div class="admin-info-section-compact">
                <span class="admin-label-compact">{{ a.status === 'approved' ? 'Approved' : 'Rejected' }} by:</span>
                <div class="admin-info-content-compact">
                  <div class="admin-avatar-small">
                    <span>{{ (a.admin_name?.charAt(0) || 'H') }}</span>
                  </div>
                  <div class="admin-details-text">
                    <span class="admin-name-text">{{ a.admin_name || 'HR' }}</span>
                    <span class="admin-date-text">{{ a.updated_at | date: 'd MMM yyyy' }}</span>
                  </div>
                </div>
              </div>
              }
            </div>

            <!-- Right Column: Status Timeline -->
            <div class="right-column">
              @if (a.leave_version == '1') {
              <div class="status-timeline-compact">
                <div class="timeline-header-compact">
                  <div class="timeline-header-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                    </svg>
                    <span>Approval Timeline</span>
                  </div>
                  
                  <!-- Status Badge in Timeline Header -->
                  <div class="status-badge-timeline" [ngClass]="{
                    'badge-approved': a.status === 'approved',
                    'badge-rejected': a.status === 'rejected',
                    'badge-recommended': a.status === 'recommended',
                    'badge-pending': a.status === 'pending'
                  }">
                    @if (a.status === 'approved') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    }
                    @if (a.status === 'rejected') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    }
                    @if (a.status === 'recommended') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                    }
                    @if (a.status === 'pending') {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    }
                    <span>{{ a.status | titlecase }}</span>
                  </div>
                </div>
                <div class="timeline-items-compact">
                  @if ((a.status === 'pending' && isPendingstatus(a)) || !isAdmindata(a)) {
                  <div class="timeline-item-compact pending-item">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div class="timeline-icon-compact">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="8" x2="12" y2="12"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                      </div>
                      <div class="timeline-content-compact">
                        <span class="timeline-status-compact">Pending Review</span>
                        <span class="timeline-subtitle-compact">Awaiting approval</span>
                      </div>
                    </div>
                  </div>
                  }
                  
                  @for (detail of a.leave_details; track detail) {
                  <div class="timeline-item-compact">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div class="timeline-icon-compact" [ngClass]="{
                        'icon-approved': detail.status === 'approved',
                        'icon-rejected': detail.status === 'rejected',
                        'icon-recommended': detail.status === 'recommended'
                      }">
                        @if (detail.status === 'approved') {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        }
                        @if (detail.status === 'rejected') {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        }
                        @if (detail.status === 'recommended') {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                        </svg>
                        }
                      </div>
                      <div class="timeline-content-compact">
                        <div class="timeline-admin-info-compact">
                          <div class="admin-avatar-small">
                            @if (detail.admin?.profile_image) {
                            <img [src]="detail.admin.profile_image" alt="Admin">
                            }
                            @else {
                            <span>{{ (detail.admin?.first_name?.charAt(0) || '') + (detail.admin?.last_name?.charAt(0) || '') }}</span>
                            }
                          </div>
                          <div>
                            <span class="timeline-admin-name-compact">{{ detail.admin?.first_name }} {{ detail.admin?.last_name }}</span>
                            <span class="timeline-status-compact" [ngClass]="{
                              'status-approved': detail.status === 'approved',
                              'status-rejected': detail.status === 'rejected',
                              'status-recommended': detail.status === 'recommended'
                            }">{{ detail.status | titlecase }}</span>
                          </div>
                        </div>
                        <span class="timeline-date-compact">{{ detail.action_date | date: 'd MMM yyyy, h:mm a' }}</span>
                        @if (detail.status === 'rejected' && detail.reason) {
                        <button class="info-button-compact" (click)="showLeaveDetail(detail)" data-toggle="modal" data-target="#infoModal">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                          </svg>
                          View Details
                        </button>
                        }
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </div>
        </div>

      </div>
      }
    </div>

    <!-- Pagination -->
    <div class="pagination-wrapper" >
      <mat-paginator [length]="arr.length" [pageSize]="pageSize" (page)="onPageChange($event)" [ngClass]="{
        'custom-paginator-theme': selectedMode === 'dark',
      }">
      </mat-paginator>
    </div>

    <!-- Old table code removed, replaced with card-based design above -->
    <!-- approve modal -->
    <div class="modal fade" id="approveModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <i class="fa fa-question-circle" style="font-size:48px;color:rgb(3, 100, 60)"></i>
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
          </div>
          <div class="modal-body">
            <p>Are you sure you want to <b> {{getApprovalButtonModalLabel(approveOrRecommendation) }}</b> this
              Leave?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            <input type="hidden" [(ngModel)]="example">
            <button type="button" class="btn btn-success" (click)="approve(example)"
              data-dismiss="modal">{{getApprovalButtonModalLabel(approveOrRecommendation) }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal -->
    <!-- reject modal -->
    <div class="modal fade hidecolor" id="rejectModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered" role="document">
        <div class="modal-content">
          <form #reason="ngForm" (ngSubmit)="reject(reason)">
            <div class="modal-btn modal-header modal-buttons-header">
              <i class="fa fa-question-circle"></i>
              <h5 class="modal-title" id="rejectModalLabel">Add Reason </h5>
            </div>
            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-12 mt-2 mb-2 text-box">
                <textarea class="form-control" id="rejected_reason" type="text" inputmode="none" rows="3"
                  name="rejected_reason" placeholder="Enter Reason " [(ngModel)]="rejectedReason" #r="ngModel"
                  required></textarea>
                @if (r.valid && r.touched) {
                <div>
                  @if (reason.value.rejected_reason.length < 50 ) { <p class="alert alert-warning mt-2">
                    Ensure that the entered <strong>Reason</strong> contains minimum of 50 characters.
                    </p>
                    }
                </div>
                }
                <!-- automated text here -->
                @if ((leaveRejectionData || []).length > 0) {
                <div class="mt-4">
                  <!-- <p>Automated Text</p> -->
                  @for (item of leaveRejectionData; track item) {
                  <div>
                    <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" id="closeButton" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success"
                [disabled]="reason.invalid || (reason.value.rejected_reason || []).length < 50">Confirm Reject</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- update modal -->
    <div class="modal fade hidecolor" id="updateModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered" role="document">
        <div class="modal-content">
          <form #updateLeave="ngForm" (ngSubmit)="update(updateLeave)">
            <div class="modal-btn modal-header modal-buttons-header updatemodal-head">
              <i class="fa fa-info-circle"></i>
              <h5 class="modal-title">Update Leave Date</h5>
            </div>
            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-12 mt-2 mb-2 text-box">
                <div class="form-group">
                  <input type="text" name="start_date" id="start_date" placeholder="Start Date - mm/dd/yyyy*" ngModel
                    #start_date="ngModel" class="form-control date-type pl-4" required [(ngModel)]="start_date_form"
                    onfocus="(this.type='date')" onblur="(this.type= this.value ? 'date' : 'text')" />
                  @if (start_date.touched && start_date.invalid) {
                  <div class="warning">
                    Select Start Date of Joining
                  </div>
                  }
                </div>
                <div class="form-group">
                  <input type="text" name="end_date" id="end_date" placeholder="end Date - mm/dd/yyyy*" ngModel
                    #end_date="ngModel" class="form-control date-type pl-4" required [(ngModel)]="end_date_form"
                    (change)="changeEndDate(updateLeave.value)" onfocus="(this.type='date')"
                    onblur="(this.type= this.value ? 'date' : 'text')" />
                  @if (end_date.touched && end_date.invalid) {
                  <div class="warning">
                    Select End Date of Joining
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" id="closeButton" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success" [disabled]="updateLeave.invalid">Confirm Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- redo modal -->
    <div class="modal fade hidecolor" id="redoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <i class="fa fa-question-circle" style="font-size:48px;color:rgb(3, 100, 60)"></i>
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
          </div>
          <div class="modal-body redu-modal-body">
            <p>Are you sure you want to <b>Redo</b> this Leave?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">No</button>
            <button type="button" class="btn btn-success" (click)="redo()" data-dismiss="modal">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <!-- info modal -->
    <div class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoModalLabel">Leave Detail</h5>
          </div>
          <div class="modal-body info-modal-body">
            <!-- Display current leave detail -->
            <div class="row">
              <div class="col-4">
                <strong>Admin:</strong>
              </div>
              <div class="col-8">
                <p> {{ currentLeaveDetail.admin.first_name }} {{ currentLeaveDetail.admin.last_name }}</p>
              </div>
              <div class="col-4">
                <strong>Status:</strong>
              </div>
              <div class="col-8">
                <p> {{ currentLeaveDetail.status | titlecase }}</p>
              </div>
              <div class="col-4">
                <strong>Action Date:</strong>
              </div>
              <div class="col-8">
                <p> {{ currentLeaveDetail.action_date | date: 'yyyy-MM-dd' }}</p>
              </div>
              <div class="col-4">
                <strong>Reason:</strong>
              </div>
              <div class="col-8">
                <!-- <p> {{ currentLeaveDetail.reason ? currentLeaveDetail.reason : 'No Reason for Approve' }}</p> -->
                <p>{{ currentLeaveDetail.reason || 'No Reason for Approve' }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</main>